import { render, staticRenderFns } from "./comisionPortal.vue?vue&type=template&id=906df208"
import script from "./comisionPortal.vue?vue&type=script&lang=js"
export * from "./comisionPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports